import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ReferentialService} from '../../../../../../../shared/services/referential/referential.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ToastrService} from 'ngx-toastr';
import {DeviceService} from '../../../../../../../shared/services/device/device.service';
import {ProjectService} from '../../../../../../../shared/services/project/project.service';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {UserService} from '../../../../../../../shared/services/user/user.service';
import {TranslateService} from '@ngx-translate/core';
import {StatesService} from '../../../../../../../shared/services/state/states.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ProjectDeviceAssignement} from '../../../../../../../shared/classes/project-device-assignement/project-device-assignement';

@Component({
  selector: 'app-project-device-assignement',
  templateUrl: './project-device-assignement.component.html',
  styleUrls: ['./project-device-assignement.component.css']
})
export class ProjectDeviceAssignementComponent implements OnInit {

  public displayedColumns: string[] = ['type', 'uid', 'action'];
  public devices: MatTableDataSource<any>;
  public faPlus = faPlus;
  public deviceTypes = [];
  public deviceTypeSelected: number = 0;
  public deviceAssignementName: string = '';
  public deviceAssignementDyndns: string = '';
  public showSpinner: boolean = false;
  public generateLocationPreference = false;
  @Input('projectId') projectId: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public activeModal: NgbActiveModal,
              private userService: UserService,
              private deviceService: DeviceService,
              private statesService: StatesService,
              private toastr: ToastrService,
              private translate: TranslateService,
              private projectService: ProjectService) {
  }

  ngOnInit() {


  }

  getDeviceAvailableByType(type: number) {
    this.showSpinner = true;
    this.deviceService.getDevicesAvailableByDevicesType(type, this.projectId)
      .subscribe(
        (data: any) => {
          this.devices = new MatTableDataSource(data);
          this.devices.filter = null;
          this.devices.sort = this.sort;
          this.devices.paginator = this.paginator;
          this.showSpinner = false;
        }
        ,
        error2 => {
          this.showSpinner = false;
        }
      );
  }

  filterListByDeviceType(type: number) {
    if (this.deviceTypeSelected !== type) {
      this.deviceTypeSelected = type;
    } else {
      this.deviceTypeSelected = 0;
    }
    if (this.deviceTypeSelected !== 0) {
      this.getDeviceAvailableByType(this.deviceTypeSelected);
    }

  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.devices.filter = filterValue;
  }

  postProjectDeviceAssignement(deviceId: number) {
    if (this.deviceAssignementName.length > 0) {
      if (this.deviceAssignementName.length > 3) {

        this.showSpinner = true;
        const projectDeviceAssignement = new ProjectDeviceAssignement();
        projectDeviceAssignement.device = deviceId;
        projectDeviceAssignement.name = this.deviceAssignementName;
        projectDeviceAssignement.dyndns = this.deviceAssignementDyndns;
        this.projectService.postProjectDeviceAssignement(this.projectId, projectDeviceAssignement, this.generateLocationPreference)
          .subscribe(
            (data: any) => {
              this.showSpinner = false;
              this.getDeviceAvailableByType(this.deviceTypeSelected);
              this.toastr.success(this.translate.instant('ADDED_DEVICE_PROJECT'), this.translate.instant('SUCCESS'));
              this.statesService.reloadProjectDevice.next();

            }
            ,
            error2 => {
              this.showSpinner = false;
            }
          );

      } else {
        this.toastr.error(this.translate.instant('DEVICE_NAME_TOO_SHORT'), this.translate.instant('ERROR'));
      }
    } else {

      this.toastr.error(this.translate.instant('DEVICE_NAME_MANDATORY'), this.translate.instant('ERROR'));
    }


  }

  useUidAsName(uid: string) {
    this.deviceAssignementName = uid;
  }

}
